export default __webpack_public_path__ + "locales/de/ChangeEmailDialog.json?hash=62b9f960250495cdb56e245e4bc8a301";